module.exports = __webpack_public_path__ + "assets/img/detail13.82c8499a.png";